exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item {\n  margin: 10px\n}\n\n.tag {\n  color: #bbb;\n  width: 100px;\n  height: 20px;\n  background: #320606;\n  border-radius: 10px;\n  padding: 2px 10px;\n  display: inline;\n  margin: 0 5px;\n}\n\nnav {\n  margin-top: 2.5rem !important;\n}\n\nnav:before {\n  height: calc(2.5rem + 1px) !important;\n  top: calc(-2.5rem - 1px) !important;\n  left: calc(50% - 0px) !important;\n}\n\n#nav2:before {\n  height: calc(1.5rem + 1px) !important;\n  top: calc(-1.5rem - 1px) !important;\n}\n#nav2 {\n  margin-top: 1.5rem !important;\n}\n\n#header .content .inner {\n  padding: 2.8rem 2rem !important;\n}\n\n#header nav ul li {\n  width: 200px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/manu/ArtCode/artCode/artCode/src/app/pages/home/home.component.css
// module id = ../../../../../src/app/pages/home/home.component.css
// module chunks = main